import React from "react"
import "./colbaButton.scss"

export const ColbaButton = ({ label, onClick, type }) => {
    return (
        <button className={`colbaButton ${type}`} onClick={onClick}>
            {label}
        </button>
    )
}
